import { render, staticRenderFns } from "./JobBoardSettings.vue?vue&type=template&id=6bc72bb8&"
import script from "./JobBoardSettings.vue?vue&type=script&lang=js&"
export * from "./JobBoardSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports